import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApplicationService } from '../../services/application/application.service';
import { ChangeDetectorRef } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { CommonService } from 'src/app/services/common/common.service';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-otp-validation-modal',
    templateUrl: './otp-validation-modal.component.html',
    styleUrls:['./otp-validation-modal.component.scss']
})
export class OTPValidationModal implements OnInit{
  @Input() mobileNumber!: string;
  @Input() pan!: string;
  @Input() dob!: string;
  @Input() requestId!:string;
  @Input() onVerified!:(otpRes:any) => Promise<void> | void ;
  showLoader: boolean = false;
  messageText = ''
  headerText = ''
  otp = new FormControl('', [
    Validators.required, 
    Validators.pattern(/^\d{6}$/)
  ]);


  timer: number = 600;
  attemptsLeft :number = 3;
  timerDisplay:string = '10:00';
  intervalRef : any;
  resentOTP:boolean = false;
  remainingSeconds = 0;

  constructor(
    private modalCtrl:ModalController,
    private cdr: ChangeDetectorRef, 
    private readonly applicationService: ApplicationService,
    private toastController: ToastController,
    private readonly commonService: CommonService
  ){}

  ngOnInit(): void {
    this.startOtpTimer();
  }

  onTimerChange(event) {
    this.remainingSeconds = event;
  }
  async handleOTPVerified(otpRes:any){
    try{
      if(this.onVerified){
        await this.onVerified(otpRes);
      }
    }catch(err){
      console.error('Error',err)
    } 
  }

  startOtpTimer(){
    clearInterval(this.intervalRef);
    this.timer = 600;
    this.intervalRef = setInterval(()=>{
      this.timer--;

      const mins = Math.floor(this.timer/60);
      const secs = this.timer % 60;
      this.timerDisplay = `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2,'0')}`;

      this.cdr.detectChanges();
      
      if(this.timer<=0){
        clearInterval(this.intervalRef);
        this.otp.setErrors({expired: true});
      }
    },1000);
  }

   resendOtp(){
    this.showLoader = true
    this.headerText = 'Re-sending OTP';
    this.messageText = "Please wait , resending the OTP"
    this.requestId = this.commonService.generateRequestId();
    let body = {
      pan : this.pan,
      dob: this.dob,
      mobile: this.mobileNumber,
      requestId: this.requestId
    }

    this.applicationService.getCKYC(body).subscribe(
      async(res:any)=>{
        if (res.message.includes('OTP has been sent to the registered mobile number')){
          this.showLoader = false;
          this.startOtpTimer()
          this.resentOTP = true;
          setTimeout(() => {
            this.resentOTP = false;
          }, 60000);
        }else{
          this.showLoader = false;
          this.otp.setErrors({reSendError: true});
        }
      }
    )
  }

  submitOtp(){
    if(this.timer <= 0){
      this.otp.setErrors({expired: true});
      return
    }
    if(this.otp.invalid){
      this.otp.markAllAsTouched();
      return
    }
    const payload = {
      otp: this.otp.value,
      requestId : this.requestId
    }
    this.showLoader = true
    this.headerText = 'OTP Check';
    this.messageText = "Please wait, Verifying otp"
    this.applicationService.validateOTP(payload).subscribe({
      next: (res:any) =>{
        if(res?.value.status.toLowerCase() === 'success'){ 
          this.handleOTPVerified(res);
        }else if(res.message.toLowerCase().includes('invalid otp')){
          this.showLoader = false
          this.attemptsLeft--;
          if(this.attemptsLeft > 0){
            this.otp.setErrors({invalid:true})
          }else{
            this.otp.setErrors({maxAttempts: true});
          }
          this.cdr.detectChanges();
        }else if(res.message.toLowerCase().includes('request id')){
          this.showLoader = false
          this.otp.setErrors({requestIdInvalid: true});
        }else{
          this.showLoader = false
           this.otp.setErrors({server:true})
        }
      }
    })



  }

  dismissModal(){
    clearInterval(this.intervalRef);
    this.modalCtrl.dismiss();
  }
}